import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';

const AdminConfirmEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const email = searchParams.get('email') || '';

  const [status, setStatus] = useState('loading'); // loading | done | error
  const [message, setMessage] = useState('');
  const submitted = useRef(false);

  useEffect(() => {
    if (submitted.current) return;
    submitted.current = true;

    if (!token || !email) {
      setStatus('error');
      setMessage('الرابط مكسور أو غير مكتمل.');
      return;
    }

    authAPI.confirmEmailChange({ token, email })
      .then(() => setStatus('done'))
      .catch((err) => {
        setStatus('error');
        setMessage(err?.response?.data?.message || 'رابط التأكيد غير صالح أو منتهي الصلاحية');
      });
  }, [token, email]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-700 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 text-center">
        <h1 className="text-3xl font-bold text-blue-800 mb-2">🚌 سافر</h1>
        <p className="text-gray-500 text-sm mb-6">تأكيد البريد الإلكتروني</p>

        {status === 'loading' && (
          <div>
            <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-sm text-gray-500">جاري تأكيد بريدك الإلكتروني...</p>
          </div>
        )}

        {status === 'done' && (
          <div>
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-lg font-bold text-gray-800 mb-2">تم تأكيد البريد الإلكتروني</h2>
            <p className="text-sm text-gray-500 mb-6">تم تحديث بريدك الإلكتروني بنجاح. الرجاء تسجيل الدخول مجدداً.</p>
            <Link to="/admin/login" className="block w-full text-center bg-blue-700 hover:bg-blue-800 text-white font-semibold py-3 rounded-lg transition">
              تسجيل الدخول
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div>
            <div className="text-5xl mb-4">❌</div>
            <h2 className="text-lg font-bold text-gray-800 mb-2">تعذّر تأكيد البريد الإلكتروني</h2>
            <p className="text-sm text-gray-500 mb-6">{message}</p>
            <Link to="/admin/login" className="block w-full text-center bg-blue-700 hover:bg-blue-800 text-white font-semibold py-3 rounded-lg transition">
              العودة لتسجيل الدخول
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminConfirmEmailPage;
